import PocketBase from 'pocketbase';
//const pb = new PocketBase('https://chowdhury.teaauction.xyz');
const pb = new PocketBase('https://fish-market.pockethost.io');

export default pb;


